import api from './api';

export const getProjectCalls = async (projectId) => {
  const response = await api.get(`/poc-calls/project/${projectId}`);
  return response.data;
};

// date: 'YYYY-MM-DD', time: 'HH:MM' — both IST.
export const scheduleCall = async (projectId, milestone, date, time) => {
  const response = await api.post(`/poc-calls/project/${projectId}/${milestone}/schedule`, { date, time });
  return response.data;
};

export const rescheduleCall = async (projectId, milestone, date, time) => {
  const response = await api.post(`/poc-calls/project/${projectId}/${milestone}/reschedule`, { date, time });
  return response.data;
};

export const cancelCall = async (projectId, milestone) => {
  const response = await api.post(`/poc-calls/project/${projectId}/${milestone}/cancel`);
  return response.data;
};

export const skipCall = async (projectId, milestone) => {
  const response = await api.post(`/poc-calls/project/${projectId}/${milestone}/skip`);
  return response.data;
};
